import React from 'react';

import { CircularProgress } from '@mui/material';
import Stack from '@mui/material/Stack';

/**
 * 공용 로딩 스피너 컴포넌트
 *
 * 데이터 로딩 중이거나 비동기 작업 처리 중일 때 표시되는 스피너입니다.
 * - 중앙 정렬된 원형 프로그레스 표시
 * - 크기 조절 가능
 * - 메모이제이션으로 성능 최적화
 *
 * @param size 스피너 크기 (기본값: 40px)
 */
function LoadingSpinner({ size = 40 }: { size?: number }) {
  return (
    <Stack alignItems={'center'} justifyContent={'center'} height={'100%'}>
      <CircularProgress size={size} />
    </Stack>
  );
}

export default React.memo(LoadingSpinner);
